// @flow
import React from 'react'
import * as ColorPickers from 'react-color'

type PropTypes = {
    onSel: Function,
    color: string,
}

class Color extends React.Component<PropTypes> {
    constructor(props) {
        super(props)
        this.state = {
            displayColorPicker: false,
            color: props.color,
        }
    }

    handleClick() {
        this.setState({ ...this.state, displayColorPicker: !this.state.displayColorPicker })
    }

    handleClose() {
        this.setState({ ...this.state, displayColorPicker: false })
    }

    handleChange(color) {
        this.setState({ ...this.state, color: color.hex })
        this.props.onSel(color)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            color: nextProps.color,
        })
    }

    render() {
        const colorStyle = {
            width: '36px',
            height: '14px',
            borderRadius: '2px',
            border: '1px solid #888',
            background: this.state.color,
        }

        const swatchStyle = {
            display: 'inline-block',
            verticalAlign: 'middle',
            padding: '2px 2px',
        }

        const popoverStyle = {
            position: 'absolute',
            zIndex: 2,
        }

        const coverStyle = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        }

        let colorPicker
        if (this.state.displayColorPicker) {
            const ColorComp = ColorPickers.CompactPicker
            colorPicker = (
                <div style={popoverStyle}>
                    <div role="button" tabIndex="-1" style={coverStyle} onClick={() => this.handleClose()} />
                    <ColorComp color={this.state.color} onChange={color => this.handleChange(color)} triangle={'hide'} />
                </div>
            )
        }
        return (
            <div style={swatchStyle}>
                <div role="button" tabIndex="-1" onClick={() => this.handleClick()}>
                    <div style={colorStyle} />
                </div>
                {colorPicker}
            </div>
        )
    }
}

export default Color
